import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { m } from "@vega-core/paraglide/messages";

type ModalButtonGroupProps = {
  cancelTestId: string;
  confirmTestId: string;
  onCancel: () => void;
  isSubmitting?: boolean;
};

export const ModalButtonGroup = ({
  cancelTestId,
  confirmTestId,
  onCancel,
  isSubmitting = false,
}: ModalButtonGroupProps) => (
  <div className="flex justify-end gap-3 pt-4">
    <ThemedButton
      dataTestId={cancelTestId}
      onClick={onCancel}
      size="default"
      type="button"
      variant="secondary"
    >
      {m.btn_cancel()}
    </ThemedButton>
    <ThemedButton
      dataTestId={confirmTestId}
      disabled={isSubmitting}
      size="default"
      type="submit"
      variant="primary"
    >
      {m.btn_confirm()}
    </ThemedButton>
  </div>
);
